export enum DataFiles {
    MENU = 'menu',
    TRANSACTION_STATUS = 'transaction_status',
    TRANSACTION_STATUS_NEW = 'transaction-status',
    CHARGE_STATUS = 'cobranca-status',
    CUSTOMER_IMPORT_STATUS = 'customer_import_status',
    ALERT_STATUS = 'alert-status',
    ALERT_TYPE = 'alert-type',
    UF = 'uf'
}